"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wallBackground = exports.wall = exports.destroyResources = exports.path = void 0;

var fetch_1 = require("@padlet/fetch");

var configure_1 = require("./configure");

function path(resourceType) {
  switch (resourceType) {
    case 'walls':
    case 'backgrounds':
      return "/" + resourceType;

    default:
      throw new Error("Unknown resource type: " + resourceType);
  }
}

exports.path = path;

function createResource(resourceType) {
  var _a = (0, configure_1.getConfiguration)(),
      host = _a.host,
      _b = _a.token,
      csrfToken = _b.csrfToken,
      oauthToken = _b.oauthToken; // authentication if required


  var fetchOptions = {};

  if (oauthToken) {
    fetchOptions.authorization = [fetch_1.HTTPAuthenticationScheme.bearer, oauthToken];
  } else if (csrfToken) {
    var actualToken = csrfToken();
    fetchOptions.headers = {
      'X-CSRF-Token': actualToken
    };
  }

  return (0, fetch_1.resource)("https://" + host + path(resourceType), fetchOptions);
}

var cache = {};
var lastConfig = null;

function hasConfigChanged() {
  if (lastConfig === null) return true;
  var currConfig = (0, configure_1.getConfiguration)();
  return currConfig.host !== lastConfig.host || currConfig.token !== lastConfig.token;
}

function getResource(resourceType) {
  // reset the cache if the configuration has changed
  if (hasConfigChanged()) {
    cache = {};
    lastConfig = (0, configure_1.getConfiguration)();
  }

  if (!cache[resourceType]) {
    cache[resourceType] = createResource(resourceType);
  }

  return cache[resourceType];
}

function destroyResources() {
  cache = {};
}

exports.destroyResources = destroyResources;

function wall() {
  return getResource('walls');
}

exports.wall = wall;

function wallBackground() {
  return getResource('backgrounds');
}

exports.wallBackground = wallBackground;